import { createSlice } from "@reduxjs/toolkit";

const initialDashboardState = {
    listLoading: false,
    actionsLoading: false,
    dailyStatistics: {},
    monthlyTransactions: [],
    monthlyRevenue: [],
    monthlyReceipts: [],
    error: null
};

export const callTypes = {
    list: "list",
    action: "action"
};

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState: initialDashboardState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        dashboardDataFetched: (state, action) => {
            state.actionsLoading = false;
            state.listLoading = false;
            state.dailyStatistics = action.payload.dailyStats;
            state.monthlyTransactions = action.payload.monthlyTrans;
            state.monthlyRevenue = action.payload.monthlyRev;
            state.monthlyReceipts = action.payload.monthlyRec;
            state.error = null;
        },
        dailyStatsFetched: (state, action) => {
            state.actionsLoading = false;
            state.listLoading = false;
            state.dailyStatistics = action.payload.dailyStats;
            state.error = null;
        },
        monthlyTransFetched: (state, action) => {
            state.actionsLoading = false;
            state.listLoading = false;
            state.monthlyTransactions = action.payload.monthlyTrans;
            state.error = null;
        },
        monthlyRevFetched: (state, action) => {
            state.actionsLoading = false;
            state.listLoading = false;
            state.monthlyRevenue = action.payload.monthlyRev;
            state.error = null;
        },
        monthlyRecFetched: (state, action) => {
            state.actionsLoading = false;
            state.listLoading = false;
            state.monthlyReceipts = action.payload.monthlyRec;
            state.error = null;
        }
    }
});

export const { actions } = dashboardSlice;
export const { reducer } = dashboardSlice;